import React, { useState } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import YouTubeVideo from '../YouTubeVideo/YouTubeVideo';

import styles from './HeroWithMedia.module.scss';
import Image from '../Image';

const HeroWithMedia = ({ title = '', preamble = '', video = '', image = {} }) => {

    return (
        <div className={styles['HeroWithMedia']}>
            <div className={styles['HeroWithMedia__Media']}>
                {!video ? (
                    <div className={styles['HeroWithMedia__Video']}>
                        <YouTubeVideo
                            videoId={video}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </div>
                ) : (
                    <div className={styles['HeroWithMedia__ImageContainer']}>
                        <Image {...image} fill={true} />
                    </div>
                )}
            </div>
            <div className={styles['HeroWithMedia__TextWrapper']}>
                <div className={styles['HeroWithMedia__Header']}>
                    <h1>{title}</h1>
                </div>
                <div className={styles['HeroWithMedia__Text']}>
                    <p>{preamble}</p>
                </div>
            </div>
        </div>
    );
};

HeroWithMedia.propTypes = {
    title: PropTypes.string,
    preamble: PropTypes.string,
    video: PropTypes.string,
    image: PropTypes.object,
};

export default HeroWithMedia;
